import { ButtonHTMLAttributes } from "react";

import { cx } from "class-variance-authority";

import * as theme from "./LinkButton.css";

type LinkButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type">;

export function LinkButton({ children, className, ...props }: LinkButtonProps) {
    return (
        <button
            type="button"
            className={cx(theme.linkButton, className)}
            {...props}
        >
            {children}
        </button>
    );
}
